import React, { Component } from 'react';
import { Form, Checkbox } from 'semantic-ui-react';
import SystemOnlyBadge from '../common/SystemOnlyBadge';

class CheckboxInput extends Component {
  render() {
    const {
      label,
      className,
      inputLabel,
      subtext,
      required,
      systemOnly,
      ...pprops
    } = this.props;
    return (
      <Form.Field className={className} required={required}>
        {label && <label>{label}</label>}
        <Checkbox label={inputLabel} {...pprops} />
        {systemOnly && <SystemOnlyBadge />}
        {subtext && <div className="input-sub">{subtext}</div>}
      </Form.Field>
    );
  }
}

export default CheckboxInput;
